var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",style:(_vm.background+';margin-top:5px;height:'+(_vm.window.width>1023?'250px':'125px;'))},[_c('Title',{attrs:{"window":_vm.window,"position":'center',"color":'white',"sondageName":_vm.sondageName}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3894f570","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resultats/components/Bandeau.vue
// module id = null
// module chunks = 